<template>
  <q-item
    clickable
    dense
    :class="{'opaque-50': count < 1}"
    @click="$emit('click')"
  >
    <q-item-section side>
      <q-checkbox
        :model-value="selected"
        class="no-pointer-events q-pl-sm"
        dense
      />
    </q-item-section>
    <q-item-section>
      <q-item-label :class="{'text-bold': count > 0}">
        {{ category || 'Uncategorised' }} ({{ count }})
      </q-item-label>
    </q-item-section>
  </q-item>
</template>

<script>
export default {
  props: {
    category: {
      type: String
    },
    selected: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    }
  },
  emits: ['click']
}
</script>
